import axios from 'axios';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import './register-account.scss';
import clsx from 'clsx';
import * as Yup from 'yup';
//import { useToast } from '../../services/ToastContext';
import { useToast } from '../../services/ToastContext';

type Props = {
  title: string;
  description?: string;
  onClose?: any;
};

const initialValues = {
  email: '',
  password: '',
  changepassword: '',
};

const registrationSchema = Yup.object().shape({
  email: Yup.string().email('Wrong email format').min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols').required('Email is required'),
  password: Yup.string().min(3, 'Minimum 3 symbols').max(50, 'Maximum 50 symbols').required('Password is required'),
  changepassword: Yup.string()
    .required('Password confirmation is required')
    .when('password', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
    }),
});

export const RegisterAccount = forwardRef((props: Props, ref) => {
  const { operatorId } = useParams();
  const {showToastMessage} = useToast();
  const toastRef: any = useRef(null);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      const resp = await axios.get(`op/${operatorId}/subdomain`);

      if (resp.data.subdomain) {
        try {
          const registerResp = await axios.post(`auth/register/account`, {email: values.email, password: values.password, subdomain: resp.data.subdomain});
          showToastMessage('Account registered succesfully!');
          setLoading(false);
          setShowAuthModal(false);
          if (props.onClose) props.onClose();
        } catch(e: any) {
          toastRef.current.toggleShow(e?.response?.data, true)
          setLoading(false);
        }
      }
    },
  });

  useImperativeHandle(ref, () => ({
    handleShow,
    handleCancel,
  }));

  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleCancel = () => {
    setShowAuthModal(false);
    if (props.onClose) props.onClose();
  };

  /*   const handleSubmit = async () => {
    const resp = await axios.get(`op/${operatorId}/subdomain`);
    console.log(resp);
  }; */

  const handleShow = () => setShowAuthModal(true);

  return (
    <section id="register-account-modal">
      <Modal show={showAuthModal} backdrop="static" onHide={handleCancel} centered dialogClassName="global-modal register-account-modal">
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {/* <ToastMessage ref={toastRef} /> */}
          <form className="form w-100" noValidate id="kt_login_signup_form" onSubmit={formik.handleSubmit}>
            <div className="register-account-content">
              <span className="description">Please enter the account details below:</span>

              <div className="">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  autoComplete="off"
                  {...formik.getFieldProps('email')}
                  className={clsx(
                    { 'is-invalid': formik.touched.email && formik.errors.email },
                    {
                      'is-valid': formik.touched.email && !formik.errors.email,
                    }
                  )}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.email}</div>
                  </div>
                )}
              </div>

              <div className="">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  autoComplete="current-password"
                  {...formik.getFieldProps('password')}
                  className={clsx(
                    {
                      'is-invalid': formik.touched.password && formik.errors.password,
                    },
                    {
                      'is-valid': formik.touched.password && !formik.errors.password,
                    }
                  )}
                />
                {formik.touched.password && formik.errors.password && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.password}</div>
                  </div>
                )}
              </div>

              <div className="">
                <label className="form-label">Confirm Password</label>
                <input
                  type="password"
                  autoComplete="off"
                  {...formik.getFieldProps('changepassword')}
                  className={clsx(
                    {
                      'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
                    },
                    {
                      'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
                    }
                  )}
                />
                {formik.touched.changepassword && formik.errors.changepassword && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.changepassword}</div>
                  </div>
                )}
              </div>
            </div>

            <div className="custom-success-footer">
              <Button onClick={handleCancel} variant="light" className="back-btn btn-short">
                <span>Cancel</span>
              </Button>

              <Button type="submit" disabled={formik.isSubmitting || !formik.isValid} className='register-btn'>
                {!loading && <span className="indicator-label">Register</span>}
                  {loading && (
                    <span className="indicator-progress" style={{ display: 'block' }}>
                      Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </section>
  );
});
